import styled from 'styled-components';

export const TableContainer = styled.div`
  margin: 16px 0;
  border-radius: ${(props) => props.theme.borders.radius.weak};
  border: 1px solid ${(props) => props.theme.colors.greys.light};
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  th,
  td {
    padding: 8px 12px;
    text-align: left;
    border-bottom: 1px solid ${(props) => props.theme.colors.greys.light};
  }

  th {
    background-color: ${(props) => props.theme.colors.greys.lighter};
    font-weight: 600;
    color: ${(props) => props.theme.colors.greys.darkest};
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:nth-child(even) {
    background-color: ${(props) => props.theme.colors.greys.lightyMedium};
  }
`;

export const ToggleButton = styled.button`
  width: 100%;
  padding: 12px;
  background-color: ${(props) => props.theme.colors.greys.lighter};
  border: none;
  border-top: 1px solid ${(props) => props.theme.colors.greys.light};
  color: ${(props) => props.theme.colors.greys.dark};
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.colors.greys.lightyMedium};
  }

  &:focus {
    outline: none;
    background-color: ${(props) => props.theme.colors.greys.lightyMedium};
  }
`;

export const ChevronIcon = styled.span`
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 6px solid ${(props) => props.theme.colors.greys.dark};
  transition: transform 0.2s ease;
  transform: ${(props) => (props.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
`;
